app.directive('programTilePreview', function () {
    return {
        restrict: 'A',
        scope: true,
        controller: function ($scope) {
            $scope.programTilePreview = {
                'description': null,
                'gender': null,
                'objective': null,
                'style': {
                    'background': '#a4c408',
                    'color': '#515556'
                }
            };
        },
        link: function ($scope, $element) {
            var descriptionTextBox = $element.find('#program_description');
            var objectiveSelect = $element.find('#program_objective');
            var genderSelect = $element.find('#program_gender');
            var colorSelect = $element.find('#program_coverColor_row');

            $scope.programTilePreview.onChange = function () {
                $scope.programTilePreview.description = descriptionTextBox.val();
                $scope.programTilePreview.objective = objectiveSelect.find('option:selected').text();
                $scope.programTilePreview.gender = genderSelect.find('option:selected').text();

                var themeValueJson = colorSelect.find(':selected, :checked').first().attr('data-theme-value');

                if (themeValueJson) {
                    var themeValue = JSON.parse(themeValueJson);
                    $scope.programTilePreview.style.background = themeValue.background;
                    $scope.programTilePreview.style.color = themeValue.color;
                } else {
                    $scope.programTilePreview.style.background = '#a4c408';
                    $scope.programTilePreview.style.color = '#515556';
                }
            };

            $scope.programTilePreview.onChange();

            $element.on('change keyup keydown', function($event) {
               $scope.$apply($scope.programTilePreview.onChange);
            });
        }
    };
});